
import { defineComponent } from 'vue'
import { mapActions, mapState } from 'vuex'
import NrTooltip from '@nextrequestco/components/src/components/NrTooltip/NrTooltip.vue'
import NrIconButton from '@nextrequestco/components/src/components/NrIconButton/nr-icon-button.vue'
import NrFormInput from '@nextrequestco/components/src/components/NrFormInput/nr-form-input.vue'
import NrModal from '@nextrequestco/components/src/components/NrModal/nr-modal.vue'
import NrLoadingAnimation from '@nextrequestco/components/src/components/NrLoadingAnimation/nr-loading-animation.vue'

export default defineComponent({
  name: 'request-custom-fields',
  components: {
    NrTooltip,
    NrIconButton,
    NrModal,
    NrFormInput,
    NrLoadingAnimation
  },
  props: {
    prettyId: { type: String },
    fields: { type: Array }
  },
  data() {
    return {
      showModal: false,
      tmp: {
        slug: null,
        label: null,
        value: null
      }
    }
  },
  computed: {
    ...mapState('request_show', ['request', 'filteredRequestLoading'])
  },
  methods: {
    ...mapActions('request_show', ['updateCustomField']),

    resetForm() {
      this.tmp = {
        slug: null,
        label: null,
        value: null
      }
    },

    handleEditField(slug: string | null = null) {
      this.showModal = true
      const activeField = this.fields.find(
        (field: { slug: string; label: string; value: any }) =>
          field.slug === slug
      )
      if (!activeField) {
        return
      }
      this.tmp = activeField
    },

    handleCloseModal() {
      this.showModal = false
      this.resetForm()
    },

    handleUpdate() {
      this.$toasted.success('Additional information updated successfully')
      this.updateCustomField({
        prettyId: this.prettyId,
        field: this.tmp
      })
      this.handleCloseModal()
    }
  }
})
